import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import StorageUtils from '@spothero/utils/storage';
import { StorageKeys, StorageTypes } from 'common/constants/storageKeys';
export const SUGGESTION_TYPE_DESTINATION = 'destination';
export const SUGGESTION_TYPE_EVENT_TITLE = 'event_title';
export const SUGGESTION_TYPE_POPULAR_EVENT = 'popular_event';
export function _persistGooglePlacesTypes(googlePlacesTypes) {
    try {
        if (Array.isArray(googlePlacesTypes) && googlePlacesTypes.length > 0) {
            StorageUtils.set(StorageKeys.SEARCH_GOOGLE_PLACES_TYPE.STORAGE_KEY, googlePlacesTypes, StorageTypes.SESSION);
        }
        else {
            StorageUtils.remove(StorageKeys.SEARCH_GOOGLE_PLACES_TYPE.STORAGE_KEY, StorageTypes.SESSION);
        }
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Failed to persist Google Places types in session storage',
        });
    }
}
function trackSearchSuggestionSelected({ userRawText, description, placeId, parkingType, powerBooking, useCurrentLocation = false, eventId = null, suggestionType = null, googlePlacesTypes = [], isRecentSearch = false, }) {
    const properties = {
        user_raw_text: userRawText,
        description,
        place_id: placeId,
        parking_type: parkingType,
        power_booking: powerBooking,
        ...(Array.isArray(googlePlacesTypes) && googlePlacesTypes.length
            ? {
                google_places_type: googlePlacesTypes.map(type => ({
                    value: type,
                })),
            }
            : {}),
        use_current_location: useCurrentLocation,
        ...(eventId && { event_id: eventId }),
        ...(suggestionType && { suggestion_type: suggestionType }),
        is_recent_search: isRecentSearch,
    };
    _persistGooglePlacesTypes(googlePlacesTypes);
    try {
        SegmentUtils.track({
            event: 'Search Suggestion Selected',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 6,
                    },
                },
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - trackSearchSuggestionSelected',
        });
    }
}
export default trackSearchSuggestionSelected;
